


























































































import { Component, Vue } from 'vue-property-decorator';
import './scala/ExpressionsEvaluater/main/target/scala-2.12/main-fastopt';
import utils from './utils';
import TreeNode from './components/TreeNode.vue';
declare const TreeBuilderAndEvaluator: any;

@Component({ components: { TreeNode } })
export default class App extends Vue {
  public expressionAsString: string = '3+(4^2+5^cos(π÷3)÷(4+2))×6';
  public evaluatedTree: object = {};

  public mode: string = 'calculator';
  public focuesdSubExpression = null;

  public lastAnswer = 0;
  public result = '';
  public syntaxError = false;

  private calc() {
    const expressionAsString = this.expressionAsString
      .replace('/', '÷')
      .replace('*', '×')
      .replace('Ans', this.lastAnswer.toString());

    try {
      const tree = TreeBuilderAndEvaluator.buildTreeFromString(
        expressionAsString,
      );
      if (tree) {
        this.result = '';
        this.evaluatedTree = TreeBuilderAndEvaluator.evaluateTree(tree);
        this.mode = 'tree-view';
      }
    } catch (err) {
      this.syntaxError = true;
    }
  }

  private addSymbol(s: string) {
    const expressionInput = this.$refs['expression-input'];
    const caretPosition = utils.getCaretPosition(expressionInput);
    this.expressionAsString =
      this.expressionAsString.substr(0, caretPosition) +
      s +
      this.expressionAsString.substr(caretPosition);
    this.$nextTick(() =>
      utils.setCaretPosition(expressionInput, caretPosition + s.length),
    );
    this.expressionChanged();
  }

  private deleteSymbol() {
    const expressionInput = this.$refs['expression-input'];
    const caretPosition = utils.getCaretPosition(expressionInput);
    this.expressionAsString =
      this.expressionAsString.substr(0, caretPosition - 1) +
      this.expressionAsString.substr(caretPosition);
    this.$nextTick(() =>
      utils.setCaretPosition(expressionInput, caretPosition - 1),
    );
    this.expressionChanged();
  }

  private clear() {
    this.expressionAsString = '';
    this.expressionChanged();
  }

  private expressionChanged() {
    this.syntaxError = false;
  }

  private async evaluate() {
    const treeView = this.$refs['tree-view'];
    if (treeView instanceof TreeNode) {
      await treeView.showSecondaryValue();

      const resultAsString: string = String(
        treeView.jsonData.secondaryValue,
      ).toString();
      const roundedResult: number =
        Math.round(parseFloat(resultAsString) * 10000) / 10000;

      this.result = roundedResult.toString();

      const result = treeView.jsonData.secondaryValue;
      this.lastAnswer = result;
    }
  }

  private back() {
    this.mode = 'calculator';
    this.clear();
  }
}
